import React, { FC } from 'react'
import { CircularProgress as MuiCircularProgress, CircularProgressProps } from 'transfix-ui/core'

export interface ICircularProgressProps extends Omit<CircularProgressProps, 'thickness'> {}

const CircularProgress: FC<ICircularProgressProps> = props => {
  return <MuiCircularProgress thickness={4} {...props} />
}

export default CircularProgress
